import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/SponsoredOffers';

export const SPONSORED_OFFERS_GET_SUCCESS = `${rootActionPath}/GET__${SUCCESS_SUFFIX}`;
export const SPONSORED_OFFERS_GET_FAILURE = `${rootActionPath}/GET__${FAILURE_SUFFIX}`;
